// get_skill
export const GET_SKILL = 'get_skill';
export const GET_SKILL_SUCCESSFUL = 'get_skill_successfull';
export const GET_SKILL_FAILED = 'get_skill_failed';

// create_skill
export const CREATE_SKILL = 'create_skill';
export const CREATE_SKILL_SUCCESSFUL = 'create_skill_successfull';
export const CREATE_SKILL_FAILED = 'create_skill_failed';

// update_skill
export const UPDATE_SKILL = 'update_skill';
export const UPDATE_SKILL_SUCCESSFUL = 'update_skill_successfull';
export const UPDATE_SKILL_FAILED = 'update_skill_failed';

// delete_skill
export const DELETE_SKILL = 'delete_skill';
export const DELETE_SKILL_SUCCESSFUL = 'delete_skill_successfull';
export const DELETE_SKILL_FAILED = 'delete_skill_failed';
